import { Grid } from "@mui/material";
import GenerGridViewItem from "./GenersGridViewItem";
import { useEffect, useState } from "react";

export default function GenersGridViewList({ modifiedGenersData, handleItemClick, hoveredIndex, setHoveredIndex, hoveredItem, setHoveredItem, handleMenuOpen, handleMenuClose }) {

  return (
    <Grid container spacing={5} sx={{ padding: 0 }}>
      {modifiedGenersData?.map((item, index) => (
        <Grid key={index}>
          <GenerGridViewItem
            index={index}
            item={item}
            modifiedGenersData={modifiedGenersData}
            handleItemClick={handleItemClick}
            handleMenuOpen={handleMenuOpen}
            handleMenuClose={handleMenuClose}
            hoveredIndex={hoveredIndex}
            setHoveredIndex={setHoveredIndex}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
        </Grid>
      ))}
    </Grid>
  );
}